enum TabsEnum {
  progress = "progress",
  plan = "plan",
}

export { TabsEnum };
